import { gql } from '@apollo/client';

export const SEND_QUIZ_NOTE = gql`
  mutation sendQuizNote($quizId: ID!, $quizRep: [QuizRep!]!) {
    createQuizNote(quiz: $quizId, reponses: $quizRep) {
      note
      quiz {
        data {
          attributes {
            name
          }
        }
      }
    }
  }
`;
